import { IAddFormPublishTermsResponse } from '../../../../../repositories/billing-tariffs/v2/add-form/publish-terms';
import { isPromotionToggleDisabled } from './isPromotionToggleDisabled';

export const isPromotionToggleChecked = (response: IAddFormPublishTermsResponse): boolean => {
  const isServicesEnabled = response.auction ? !response.auction.withoutPromotion : false;
  const isPromotionDisabled = isPromotionToggleDisabled(response);

  return isPromotionDisabled ? false : isServicesEnabled;
};
